import React, { useState, useRef } from "react";
import PhoneNumberInput from '../../../../components/common/PhoneNumberInput';
import AppFormInput from '../../../../components/ui/AppFormInput';
import apiClient from "../../../../services/api-client";
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from "primereact/inputswitch";
import { confirmDialog } from 'primereact/confirmdialog';
import { useMountEffect } from 'primereact/hooks';
import StorageHelper from '../../../../utils/storage-helper';


const EditUser = ({ onCloseDialog, employeeData }) => {
//   //console.log("Employee Data:", employeeData);

    const [firstName, setFirstName] = useState(employeeData.firstName);
    const [lastName, setLastName] = useState(employeeData.lastName);
    // const [email, setEmail] = useState(employeeData.emailAddress);
    const [idNumber, setIdNumber] = useState(employeeData.idnumber);
    const [email, setEmail] = useState(employeeData.emailAddress);
    const [phoneNumber, setPhoneNumber] = useState(employeeData.phoneNumber);
    const [userStatus, setUserStatus] = useState(employeeData.isActive);
    const [userRole, setUserRole] = useState(employeeData.userRole.id);
    const [, setAllSystemRoles] = useState(null)
    const [selectedRole, setSelectedRole] = useState(null)

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        idNumber: ''
    });
    



    useMountEffect(() => {
        // //console.log(JSON.stringify(employeeData))
        fetchRoles();
      }, []);

      const [options, setOptions] = useState([]);

      const fetchRoles = async () => {
        try {
          const response = await apiClient.get('system/roles', {
            headers: {
              Authorization: 'Bearer ' + StorageHelper.get('token'),
              'Content-Type': 'application/json'
            }
          });
          setAllSystemRoles(response.data.responseBody);
      
          const newOptions = response.data.responseBody.map(element => ({
            label: element.name,
            value: element.id,
            description: element.description
          }));
      
          setOptions(newOptions);
        } catch (error) {
        //   console.error(error);
        }
      };


    const handleUserRoleChange = (val)=>{

        setUserRole(val)
        options.forEach(element => {
            ////console.log(element)

            if(element.value === val){
                setSelectedRole(element)
            }
        });
    }
   
    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Cancel', detail: 'You have cancelled', life: 3000 });
    }

    const confirmUpdate = (e) => {

        e.preventDefault();
        const validation = validateUser(e)

        if (validation === true) {
            confirmDialog({
                message: "Are you sure you want to update this?",
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: registerUser,
                reject
            });
        }
        else{
            //console.log("Not ")
        }
    };

    const toast = useRef(null);


    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    // const handleSubmit = (e) => {
    //     //console.log(validation)

    //     if (validation === true) {
    //         registerUser()
    //     }
    // };


    const registerUser = async () => {
        let userPayload = {
            "operation": "create-user-profile",
            "requestBody": {
                "userId": employeeData.userId,
                "firstName": firstName,
                "lastName": lastName,
                "emailAddress": email,
                "phoneNumber": phoneNumber,
                "idnumber": idNumber,
                "isActive": true,
                "locked": false,
                "enabled": true,
                "userType": "EMPLOYEE",
                "userRole": userRole
            }
        };

        const token = StorageHelper.get('token')

        const config = {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        };

        try {
            const response = await apiClient.put('user/edit', userPayload, config);
            // //console.log(response.data);
            if (response.data.status === 'FAILED') {
                toast.current.show({ severity: 'error', sticky: true, summary: 'Failed', detail: response.data.message });
            } else {
                onCloseDialog({ success: true });
            }
        } catch (error) {
            // console.error(error);
        }
    };

    const validateUser = (e) => {
        let formIsValid = true;
        const newErrors = { ...errors };

        // Validate First Name
        if (!firstName.trim()) {
            newErrors.firstName = 'First name is required';
            formIsValid = false;
        } else {
            newErrors.firstName = '';
        }

        // Validate Last Name
        if (!lastName.trim()) {
            newErrors.lastName = 'Last name is required';
            formIsValid = false;
        } else {
            newErrors.lastName = '';
        }

        // Validate Email
        if (!email.trim()) {
            newErrors.email = 'Email is required';
            formIsValid = false;
        } else if (!validateEmail(email)) {
            newErrors.email = 'Invalid email format';
            formIsValid = false;
        } else {
            newErrors.email = '';
        }

        // Validate Phone Number
        if (!phoneNumber.trim()) {
            newErrors.phoneNumber = 'Phone number is required';
            formIsValid = false;
        } else if (!/^\d{5,}$/.test(phoneNumber)) {
            newErrors.phoneNumber = 'Phone number should be more than 5 digits';
            formIsValid = false;
        } else {
            newErrors.phoneNumber = '';
        }

        if (formIsValid) {
            setErrors({});
            return true;
        } else {
            setErrors(newErrors);
            return false;
        }
    };

    return (
        
        <>
            <Toast ref={toast} />
            <div className="w-full mt-2">
                <div className="flex flex-col gap-4">
                    <AppFormInput label="First Name" id="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} error={errors.firstName} />

                    <AppFormInput label="Last Name" id="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} error={errors.lastName} />
                    
                    <AppFormInput label="National ID Number" id="idNumber" value={idNumber} onChange={(e) => setIdNumber(e.target.value)} error={errors.idNumber} />

                    <AppFormInput label="Email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} error={errors.email} />

                    <PhoneNumberInput label="Phone" value={phoneNumber} onChange={(val) => setPhoneNumber(val)} error={errors.phoneNumber} />

                    <div className="form-control w-full">
                        <label className="label py-1"><span className="label-text text-xs font-bold text-slate-700">User Role</span></label>
                        <Dropdown
                            className="w-full"
                            id="userRole"
                            value={userRole}
                            options={options}
                            onChange={(e) => handleUserRoleChange(e.value)}
                            placeholder="Select a role"
                        />
                        {selectedRole && selectedRole.description && (
                            <span className="text-info text-xs mt-1">{selectedRole.description}</span>
                        )}
                    </div>

                    <div className="form-control w-full mt-2">
                        <label className="label cursor-pointer justify-start gap-4 p-4 border border-base-200 rounded-lg bg-base-50/50 hover:bg-base-100 transition-colors">
                            <InputSwitch
                                id="value"
                                name="value"
                                checked={userStatus}
                                onChange={(e) => {
                                    let message = !userStatus ? 'User will be active' : 'User will be disabled';
                                    toast.current.show({ severity: 'info', summary: 'User Status', detail: message });
                                    setUserStatus(e.value);
                                }}
                            />
                            <span className="label-text font-medium text-gray-700">
                                {userStatus ? 'Account is disabled?' : 'Account is active?'}
                            </span>
                        </label>
                    </div>

                    <div className="mt-6 flex justify-end pt-4 border-t border-base-200">
                        <button type="button" onClick={confirmUpdate} className="btn btn-primary px-8 text-white rounded-lg shadow-sm">
                            <i className="pi pi-check"></i> Update User
                        </button>
                    </div>
                </div>
            </div>
        </>

    );
};

export default EditUser;
